<template>
  <el-dialog :title="pushType === 2 ? '紧急通知' : '消息详情'"
             :visible.sync="visible"
             @close="close"
             class="comp-message-dialog"
  >
    <div v-loading="loading">
      <div class="m-head">
        <p class="title" v-html="message.title"></p>
        <p class="sub-title">{{message.publish_time}}</p>
      </div>
      <div class="m-body" v-html="message.content"></div>
      <div class="m-footer" v-if="!pushType">
        <span v-if="message.lastId || message.nextId">阅读：</span>
        <span><a href="javascript:void(0)" v-show="message.lastId" @click="updateId(message.lastId)">下一篇消息</a></span>
        <span class="spacer" v-show="message.nextId && message.lastId">|</span>
        <span><a href="javascript:void(0)" v-show="message.nextId" @click="updateId(message.nextId)">上一篇消息</a></span>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="visible = false">知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        message: {},
        id: null,
        isRead: false,
        pushType: 0,
        loading: true
      };
    },
    methods: {
      init (isHQ) {
        this.isHQ = isHQ;
        let _this = this,
            data = {
              id: _this.id,
              platform: isHQ ? 'HQ' : 'IRS',
              isRead: _this.isRead
            };
        _this.loading = true;
        _this.$axios.post('/crm-api/ces-web/user/api/v3/message/detail', _this.$qs.stringify(data)).then((res) => {
          _this.loading = false;
          _this.message = res.data;
          if (_this.message.is_read === 0) {
            this.getUnreadMessageInfo(isHQ);
          }
        });
      },
      getUnreadMessageInfo (isHQ) {
        let queryData = {platform: isHQ ? 'HQ' : 'IRS', isRead: 0, start: 0, size: 3};
        return this.$axios.post('/crm-api/ces-web/user/api/v3/message/totalList', this.$qs.stringify(queryData))
          .then((res) => {
            global.vm.$emit('refresh_message', res.data);
          });
      },
      updateId (newId) {
        this.id = newId;
        this.init(this.isHQ);
      },
      show (id, isRead, pushType, isHQ) {
        this.id = id;
        this.isRead = isRead;
        this.pushType = +pushType;
        this.init(isHQ);
        this.visible = true;
        this.message = {};
      },
      close () {
        this.$emit('close');
        this.getUnreadMessageInfo(this.isHQ);
      }
    }
  };
</script>

<style lang="less">
  .comp-message-dialog {
    line-height: 40px;

    .m-head {
      background: #f8f8f8;
      height: 50px;
      padding: 15px 20px;

      .title {
        font-size: 18px;
        color: #333333;
        line-height: 30px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .sub-title {
        font-size: 12px;
        color: #9b9b9b;
        line-height: 20px;
      }
    }

    .m-body {
      margin: 20px 0 30px;
      max-height: 400px;
      overflow-x: hidden;
      overflow-y: auto;
      line-height: normal;
    }
    .m-footer {
      .spacer {
        margin: 0 10px;
      }
      a {
        color: #016cdf;
        text-decoration: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MessageDialog.vue?6bffd4db